import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { useRoles } from '@/hooks/auth'
import { Role } from '@/constants/role'
import Day0RoasBaseline from '@/features/dr'
import CostBaseline from '@/features/cost-baseline'
import ProfitBaseline from '@/features/profit-baseline'
import EarningRate from '@/features/er'

const TabItems = [
  { name: 'DR', value: 'dr' },
  { name: 'ER', value: 'er' },
  { name: 'Cost', value: 'cost' },
  { name: 'Profit', value: 'profit' },
]

const TabItem = ({ name, value, isActive, onClick }) => (
  <button
    onClick={onClick}
    className={cn(
      'transition-colors border-b-2 px-2 py-2 text-sm font-medium',
      {
        'text-primary font-bold border-b-primary': isActive,
        'text-foreground/60 hover:text-primary border-b-transparent':
          !isActive,
      },
    )}
  >
    {name}
  </button>
)

const Index = () => {
  const hasRole = useRoles([Role.Admin, Role.BuyerLeader, Role.RevenuerLeader])
  const [activeTab, setActiveTab] = useState('dr')

  if (!hasRole) {
    return <Navigate to="/403" />
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'dr':
        return <Day0RoasBaseline />
      case 'cost':
        return <CostBaseline />
      case 'profit':
        return <ProfitBaseline />
      case 'er':
        return <EarningRate />
      default:
        return <Day0RoasBaseline />
    }
  }

  return (
    <div className="flex flex-col w-full">
      <div className="flex items-center mt-2 mb-2 gap-4 xs:mt-1 xs:mb-1 lg:gap-6 border-b bg-transparent p-0">
        {TabItems.map(({ name, value }) => (
          <TabItem
            key={value}
            name={name}
            value={value}
            isActive={activeTab === value}
            onClick={() => setActiveTab(value)}
          />
        ))}
      </div>
      <div className="mt-2">{renderContent()}</div>
    </div>
  )
}

export default Index
